import { AutoComplete } from 'antd';
import React, { useEffect, useState } from 'react';
import { getUnit } from '../store/utils';

const ageUnits = ['Years', 'Months', 'Days'];

const AgeSelector: React.FC<{
    value?: { value: string; unit?: string };
    onSelect: (value: { unit?: string; value: string }) => void;
    disabled: boolean;
}> = ({ value, onSelect, disabled }) => {
    const ageString = value ? [value.value, value.unit].join(' ') : '';
    const [age, setAge] = useState<string | undefined>(ageString);
    const [ageValue, setAgeValue] = useState<string | undefined>(value?.value);

    useEffect(() => {
        if (!value?.value) {
            setAge(undefined);
            setAgeValue(undefined);
        }
    }, [value]);

    useEffect(() => {
        const ageString = value ? [value.value, value.unit].join(' ') : '';
        setAge(ageString);
        setAgeValue(value?.value);
    }, [disabled]);

    return (
        <AutoComplete
            options={
                ageValue
                    ? ageUnits.map((unit) => {
                          const ageV = ageValue.trim();
                          const un = getUnit(unit, ageV ?? '');
                          const ageStr = [ageV, un].join(' ');

                          return {
                              value: ageStr,
                          };
                      })
                    : undefined
            }
            value={age}
            placeholder="Enter age"
            allowClear
            showArrow
            onSelect={(value: any) => {
                const age = value ? value.split(' ') : [];
                setAge(value);
                setAgeValue(age[0]);
                onSelect({ value: age[0], unit: age[1] });
            }}
            onChange={(value: any) => {
                setAge(value);
                onSelect({ value });
            }}
            className="w-full"
            onClear={() => {
                setAge(undefined);
                setAgeValue(undefined);
            }}
            onSearch={setAgeValue}
            disabled={disabled}
        />
    );
};

export default AgeSelector;
